export enum CustomerDisplayMediaType {
  IMAGE = "IMAGE",
  VIDEO = "VIDEO",
}
